import * as eHubApi from "./data.service";

export function createKPIUserRange(req) {
  return eHubApi.post("/api/kpi-user-range/create", req);
}

export function getKPIUserRangeList(req) {
  return eHubApi.get(`/api/kpi-user-range/list?active=${req.active}`);
}

export function getKPIUserRange(req) {
  return eHubApi.get(`/api/kpi-user-range/get?name=${req.name}`);
}

export function editKPIUserRange(req) {
  return eHubApi.put(`/api/kpi-user-range/edit?name=${req.originalName}`, req);
}

export function deactivateKPIUserRange(req) {
  return eHubApi.del(`/api/kpi-user-range/delete?name=${req.name}`);
}
export function activateKPIUserRange(req) {
  return eHubApi.put(`/api/kpi-user-range/activate?name=${req.name}`);
}
export function getKPIUserRangeStatusCount() {
  return eHubApi.get("/api/kpi-user-range/get-status-count");
}

export function getKPIProductivityList(req) {
  return eHubApi.get(`/api/kpi-productivity/list?active=${req.active}`);
}

 export function createKPIProductivityRange(req) {
   return eHubApi.post("/api/kpi-productivity-range/create", req);
 }

export function getKPIProductivityRangeList(req) {
  return eHubApi.get(`/api/kpi-productivity-range/list?active=${req.active}`);
}

 export function getKPIProductivityRange(req) {
   return eHubApi.get(`/api/kpi-productivity-range/get?name=${req.name}`);
 }

 export function editKPIProductivityRange(req) {
   return eHubApi.put(`/api/kpi-productivity-range/edit?name=${req.originalName}`, req);
 }

export function deactivateKPIProductivityRange(req) {
  return eHubApi.del(`/api/kpi-productivity-range/delete?name=${req.name}`);
}
export function activateKPIProductivityRange(req) {
  return eHubApi.put(`/api/kpi-productivity-range/activate?name=${req.name}`);
}
 export function getKPIProductivityRangeStatusCount() {
   return eHubApi.get("/api/kpi-productivity-range/get-status-count");
 }

//
 export function getKPITeamList(req) {
  return eHubApi.get(`/api/kpi-team/list?active=${req.active}`);
}

export function getKPITeamStatusCount() {
  return eHubApi.get("/api/kpi-team/get-status-count");
}

export function createKPITeam(req) {
  console.log(req,"from data service");
  return eHubApi.post("/api/kpi-team/create", req);
}

export function deactivateKPITeam(req) {
  return eHubApi.del(`/api/kpi-team/delete?id=${req.id}`);
}
export function activateKPITeam(req) {
  return eHubApi.put(`/api/kpi-team/activate?id=${req.id}`);
}

export function getKPITeam(req) {
  return eHubApi.get(`/api/kpi-team/get?id=${req.id}`);
}

export function editKPITeam(req) {
  return eHubApi.put(`/api/kpi-team/edit?id=${req.id}&team=${req.team}`, req);
}

export function getKPIPicker(req) {
  console.log(req,"fromdataservice");
  return eHubApi.get(`/api/kpi-dashboard/pickerkpi?customer=${req.customer}`);
}

export function getKPITeamConfig(req) {
  console.log(req,"fromdataservice");
  return eHubApi.get(`/api/kpi-dashboard/get?team=${req.team}`);
}

export function getKPITeamName() {
  return eHubApi.get(`/api/kpi-dashboard/get-team-name`);
}

export function getKPIQC(req) {
  return eHubApi.get(`/api/kpi-dashboard/qckpi?customer=${req.customer}`);
}

export function retrieveKPIDashboardList(req){
  let url = `/api/kpi-dashboard/export-kpi-dashboard-list?teamname=${req.teamname}&startdate=${req.startdate}&enddate=${req.enddate}`;
  
    return eHubApi.post_file(url)
  }
